import { useState, useEffect } from 'react';
import { FiCheck, FiX } from 'react-icons/fi';
import { useFormContext } from 'react-hook-form';
import { cn } from '@eliadmin/core/src/utils/style-utils';

type AddCourseStepperProps = {
  currentStep: number;
  setCurrentStep: (step: number) => void;
  currentErrorStep: number | null;
  defaultAllCompleted?: boolean;
};

// Jediný krok formulára vytvorenia kurzu
const steps = ['Údaje o vzdelávacom kurze'];

export const AddCourseStepper = ({
  currentStep,
  setCurrentStep,
  currentErrorStep,
  defaultAllCompleted = false,
}: AddCourseStepperProps) => {
  const [clickedStepsIndexes, setClickedStepsIndexes] = useState<number[]>(
    defaultAllCompleted ? steps.map((_, idx) => idx) : [],
  );
  const [lastClickedStep, setLastClickedStep] = useState<number | null>(null);
  const form = useFormContext();

  useEffect(() => {
    if (currentStep !== null) {
      setLastClickedStep(prevLast => {
        if (prevLast !== currentStep) {
          if (prevLast != null && !clickedStepsIndexes.includes(prevLast)) {
            setClickedStepsIndexes(prev => [...prev, prevLast]);
          }
          return currentStep;
        }
        return prevLast;
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep]);

  const handleSetCurrentStep = (index: number) => {
    setCurrentStep(index);
  };

  return (
    <div className="hidden pr-4 md:block md:min-w-[300px] md:max-w-[300px]">
      <div className="mb-4 flex flex-col gap-1 text-base leading-[20px]">
        {steps.map((label, index) => (
          <div
            key={index}
            className={`flex cursor-pointer items-center gap-3 rounded-lg p-4 text-black hover:bg-white ${
              currentStep === index ? 'bg-white font-bold' : 'pr-7 font-normal'
            }`}
            onClick={() => handleSetCurrentStep(index)}
          >
            <div
              className={cn(
                'flex max-h-5 min-h-5 min-w-5 max-w-5 items-center justify-center rounded-full border border-border bg-white',
                index === currentStep && 'bg-white',
                clickedStepsIndexes.includes(index) && 'bg-primary',
                currentErrorStep === index && 'bg-red-500',
              )}
            >
              {((lastClickedStep !== index && index !== currentStep) ||
                clickedStepsIndexes.includes(index)) &&
                index !== currentErrorStep && <FiCheck className="text-white" />}
              {currentErrorStep === index && <FiX className="text-white" />}
            </div>
            <div>{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
